export const computeTimeLeft = (progress: number, timeElapsedSeconds: number) =>
	(timeElapsedSeconds / progress) * (100 - progress);
